import React, { useEffect, useRef } from 'react';
import './style.scss'

import { useField } from '@unform/core';

function Textarea({ name, titulo, col, hidden, ...props }) {
    const inputRef = useRef(null);
    const { fieldName, defaultValue, registerField, error } = useField(name);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
        });
    }, [fieldName, registerField]);

    return (
        <div className={`cInputD ${col}`} style={{ display: `${hidden ? 'none' : ''}` }}>
            <label htmlFor={name}>{titulo}</label>
            <textarea id={name} autoComplete='off' ref={inputRef} defaultValue={defaultValue} {...props} />
            {error && <span className="error-validacao">{error}</span>}
        </div>
    );
}

export default Textarea